import { ActionTypes } from './types';
import { ThunkResult } from '../../types';

export const rankingAnswersAreSelected = (answers: any, questionId: string): ThunkResult => dispatch => {
  dispatch({
    type: ActionTypes.QUESTION_RANKING_ANSWERS_ARE_SELECTED,
    payload: { answers, questionId }
  });
};
